import { render, staticRenderFns } from "./BudgetCounter.vue?vue&type=template&id=951d89c4&scoped=true&"
import script from "./BudgetCounter.vue?vue&type=script&lang=js&"
export * from "./BudgetCounter.vue?vue&type=script&lang=js&"
import style0 from "./BudgetCounter.vue?vue&type=style&index=0&id=951d89c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951d89c4",
  null
  
)

export default component.exports